import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Pagination from '../pagination/Pagination.jsx'
import Button from '../Button.jsx'
import Flash from '../flash/Flash.jsx'
import { ListPlatformPolicies, DeletePlatformPolicy, PlatformPolicyFindOption, PlatformPolicyFindRestriction } from '../../repo/PlatformPoliciesRepo.js'
import { GetTournament } from '../../repo/TournamentsRepo.js'

export default function AdminPlatformPoliciesList({tournamentId, ...props}) {
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page') || "1";

  const [tournament, setTournament] = useState()
  const [platformPolicies, setPlatformPolicies] = useState([])
  const [pagination, setPagination] = useState(null)
  const [currentPage, setCurrentPage] = useState(page)
  const [showFlashMessage, setShowFlashMessage] = useState(false)

  const handlePaginationClick = async (newPlatformPoliciesPage) => {
    setCurrentPage(newPlatformPoliciesPage)

    window.history.replaceState(null, "Bolão: Admin Platform Policies", "?page=" + newPlatformPoliciesPage)
  }

  const handleDeletePlatformPolicyClick = (tournamentId, platformPolicyId) => {
    if (window.confirm("Delete?")) {
      deletePlatformPolicy(tournamentId, platformPolicyId).then(deleted => {
        if (deleted) {
          loadPlatformPolicies(1)
          window.history.replaceState(null, "Bolão: Admin Platform Policies", '')
          setShowFlashMessage(true)
        }
      })
    }
  }

  const handleEditPlatformPolicyClick = (tournamentId, platformPolicyId) => {
    window.location.href = "/cocofantoelefanto/tournaments/" + tournamentId + "/platform-policies/" + platformPolicyId + "/edit"
  }

  useEffect(() => {
    loadPlatformPolicies(currentPage)
  }, [currentPage])

  useEffect(() => {
    if (tournament) {
      props.setTournamentFullNameOnLoad(tournament.name + " " + tournament.edition)
    }
  }, [tournament, props])

  async function loadPlatformPolicies(page) {
    const tournament = await GetTournament(tournamentId)
    setTournament(tournament)

    const resData = await ListPlatformPolicies(tournamentId, page)
    setPlatformPolicies(resData.data)
    setPagination(resData.pagination)
  }

  return (
    <>
      {showFlashMessage && (
        <Flash message="Platform policy was successfully deleted" type="success" timer={5000}/>
      )}
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 mt-4">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
          <tr>
            <th scope="col" className="px-6 py-3">Platform</th>
            <th scope="col" className="px-6 py-3">Restriction</th>
            <th scope="col" className="px-6 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
        {platformPolicies.map((platformPolicy) => {
          return (
            <tr key={platformPolicy.id} className="odd:bg-white even:bg-gray-50 border-b border-gray-200">
              <td className="px-4 py-2">
                <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${tournamentId}/platform-policies/${platformPolicy.id}`}>{PlatformPolicyFindOption(platformPolicy.platform_name)?.name}</Link>
              </td>
              <td className="px-4 py-2">
                {PlatformPolicyFindRestriction(platformPolicy.restriction)?.name}
              </td>
              <td className="px-4 py-2 space-x-2">
                <Button styleName="yellow" onClick={() => handleEditPlatformPolicyClick(tournamentId, platformPolicy.id)}>Edit</Button>
                <Button styleName="red" onClick={() => handleDeletePlatformPolicyClick(tournamentId, platformPolicy.id)}>Delete</Button>
              </td>
            </tr>
          )
        })}
        </tbody>
      </table>

      <Pagination pagination={pagination} onPaginationClick={handlePaginationClick} />
    </>
  )
}

async function deletePlatformPolicy(tournamentId, platformPolicyId) {
  return DeletePlatformPolicy(tournamentId, platformPolicyId)
}
